import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'
import filter from 'lodash/filter'

import Select from '../../components/forms/redux-single-select'

import { loadWorkOrdersForLocation } from '../../actions/work-orders'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.workOrdersByLocation.${ownProps.locationId}`, {})
  const workOrders = at(state.workOrders, pagination.ids || [])

  const options = workOrders.map((workOrder) => (
    {
      value: workOrder.id,
      label: workOrder.startsAt.format('MMMM D, YYYY [at] h:mm A')
    }
  ))

  return {
    options,
    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadWorkOrdersForLocation(ownProps.locationId))

  return {
    onMenuScrollToBottom () {
      dispatch(loadWorkOrdersForLocation(ownProps.locationId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/forms/work-order-selector-container.js